import { Card } from '../../components/ui.js';
import { ProjectMessages } from '../../components/Discussion.js';
import { useProjectContext } from './ProjectShell.js';

/** The founder's messaging area: talk to the team; story comments appear here too. */
export function MessagesPage() {
  const { project } = useProjectContext();
  return (
    <Card>
      <h2 className="mb-1 font-title text-2xl tracking-wide">Messages</h2>
      <p className="mb-4 text-sm opacity-70">
        Exchange ideas with our team. Comments left on a user story show up here as well.
      </p>
      <ProjectMessages
        projectId={project.id}
        canMarkInternal={false}
        autoMarkRead
        storyHref={(storyId) => `/projects/${project.id}/stories?story=${storyId}`}
      />
    </Card>
  );
}
